unit View.Logs_Sistema.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, System.StrUtils, UUtils, UWeb.Enum, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces;

type
  TFViewLogs_SistemaList = class(TForm)
    Logs_SistemaDataset: TXDataWebDataSet;
    Logs_SistemaDatasettabela: TStringField;
    Logs_SistemaDatasetservidor: TIntegerField;
    Logs_SistemaDatasetoperacao: TStringField;
    Logs_SistemaDatasetlog: TStringField;
    Logs_SistemaDatasetinclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    Logs_SistemaDatasetusuarionome: TXDataWebDatasetField;
    Logs_SistemaDatasetaliadoNome_Fantasia: TXDataWebDatasetField;
    edtLog: TEdit;
    Logs_SistemaDatasetaliadocidadeNome: TXDataWebDatasetField;
    Logs_SistemaDatasetaliadocidadeufSigla: TXDataWebDatasetField;
    cbbServidor: TComboBox;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure cbbServidorChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FFiltroTodosServidores : string;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure PreencherCombo;
    function GetFiltroCombo : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewLogs_SistemaList: TFViewLogs_SistemaList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewLogs_SistemaList }

procedure TFViewLogs_SistemaList.cbbServidorChange(Sender: TObject);
begin
  edSearch.Text := EmptyStr;
  cbPageSize.ItemIndex := 0;

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltroCombo;
  FGridPlugin.Load;
end;

procedure TFViewLogs_SistemaList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewLogs_SistemaList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewLogs_SistemaList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewLogs_SistemaList, AElementID, Result, @AfterCreate);
end;

procedure TFViewLogs_SistemaList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewLogs_SistemaList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := TUtils.FTempoTimerConsulta;
  tmrConsulta.Enabled := True;
end;

function TFViewLogs_SistemaList.GetFiltroCombo: string;
begin
  if cbbServidor.Text = 'SERVICE' then
    Result := 'servidor eq 1'
  else if cbbServidor.Text = 'WHATSAPP' then
    Result := 'servidor eq 2'
  else if cbbServidor.Text = 'MENSAGENS' then
    Result := 'servidor eq 3'
  else if cbbServidor.Text = 'API VEICULOS' then
    Result := 'servidor eq 4'
  else if cbbServidor.Text = 'API CPFS' then
    Result := 'servidor eq 5'
  else if cbbServidor.Text = 'API CNPJS' then
    Result := 'servidor eq 6'
  else
    Result := FFiltroTodosServidores;
end;

procedure TFViewLogs_SistemaList.PreencherCombo;
var
  lIndice : Integer;
begin
  cbbServidor.Items.Add('TODOS');

  if TUtils.VerificarAcessoServidor(TServidor.SERVICE, TUtils.FUsuario.PerfilAcesso) then
  begin
    FFiltroTodosServidores :=  '(servidor eq 1) or ' + FFiltroTodosServidores;
    cbbServidor.Items.Add('SERVICE');
  end;

  if TUtils.VerificarAcessoServidor(TServidor.WHATSAPP, TUtils.FUsuario.PerfilAcesso) then
  begin
    FFiltroTodosServidores :=  '(servidor eq 2) or ' + FFiltroTodosServidores;
    cbbServidor.Items.Add('WHATSAPP');
  end;

  if TUtils.VerificarAcessoServidor(TServidor.MENSAGENS, TUtils.FUsuario.PerfilAcesso) then
  begin
    FFiltroTodosServidores :=  '(servidor eq 3) or ' + FFiltroTodosServidores;
    cbbServidor.Items.Add('MENSAGENS');
  end;

  cbbServidor.Items.Add('API VEICULOS');
  cbbServidor.Items.Add('API CPFS');
  cbbServidor.Items.Add('API CNPJS');

  FFiltroTodosServidores :=  '(servidor eq 4) or ' + FFiltroTodosServidores;
  FFiltroTodosServidores :=  '(servidor eq 5) or ' + FFiltroTodosServidores;
  FFiltroTodosServidores :=  '(servidor eq 6) or ' + FFiltroTodosServidores;

  Delete(FFiltroTodosServidores, Length(FFiltroTodosServidores) - 3, 4);

  FFiltroTodosServidores := '(' + FFiltroTodosServidores + ')';

  case DMConnection.FServidor of
    SERVICE: lIndice := cbbServidor.Items.IndexOf('SERVICE');
    MENSAGENS: lIndice := cbbServidor.Items.IndexOf('MENSAGENS');
    WHATSAPP: lIndice := cbbServidor.Items.IndexOf('WHATSAPP');
  end;

  if lIndice = -1 then
    lIndice := 0;

  cbbServidor.ItemIndex := lIndice;
end;

procedure TFViewLogs_SistemaList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := TUtils.FTempoTimerConsulta;
end;

procedure TFViewLogs_SistemaList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewLogs_SistemaList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordLog: string;

  procedure VerLogButtonClick(Sender: TObject);
  var
    JSONObj: JSValue;
  begin
    if (RecordLog[1] = '{') or (RecordLog[1] = '[') then
    begin
      JSONObj := TJSJSON.parse(RecordLog);
      edtLog.Text := TJSJSON.stringify(JSONObj, nil, 2);
    end
    else
      edtLog.Text := RecordLog;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Log' then
  begin
    RecordLog := Trim(Logs_SistemaDataset.FieldByName('log').AsString);

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-clipboard-list"></i>';
    Button.OnClick := @VerLogButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_log');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Visualizar Log');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
    Button.ElementHandle.setAttribute('data-bs-target', '#modal_log');
  end;
end;

procedure TFViewLogs_SistemaList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['tabela', 'operacao',
      'usuario.nome', 'aliado.Nome_Fantasia', 'aliado.cidade.Nome']) of
      0, 1, 2, 3, 4 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewLogs_SistemaList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
var
  lRota : string;
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['aliado.Nome_Fantasia', 'servidor',
      'tabela', 'aliado.cidade.Nome', 'usuario.nome']) of
      0, 4:
      begin
        if AValue = 'null' then
          AValue := '';
      end;
      1:
      begin
        case StrToInt(AValue) of
          1: AValue := '<div class="rounded-pill" style="background-color: #1E90FF;color:white; padding-right: 5px;padding-left: 5px;">Service</div>';
          2: AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">WhatsApp</div>';
          3: AValue := '<div class="rounded-pill" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Mensagens</div>';
          4: AValue := '<div class="rounded-pill" style="background-color: #A020F0;color:white; padding-right: 5px;padding-left: 5px;">Api Veículos</div>';
          5: AValue := '<div class="rounded-pill" style="background-color: #778899;color:white; padding-right: 5px;padding-left: 5px;">API CPFs</div>';
          6: AValue := '<div class="rounded-pill" style="background-color: #B0C4DE;color:white; padding-right: 5px;padding-left: 5px;">API CNPJs</div>';
        end;
      end;
      2:
      begin
        lRota := AValue.Replace('_', ' ');
        lRota := AnsiProperCase(lRota, [' ']);
        AValue := lRota;
      end;
      3:
      begin
        if AValue = 'null' then
          AValue := ''
        else
          AValue := AValue + ' - ' + Logs_SistemaDataset.FieldByName('aliado.cidade.uf.Sigla').AsString;
      end;
    end;
  end;
end;

procedure TFViewLogs_SistemaList.WebFormCreate(Sender: TObject);
begin
  if DMConnection.FServidor <> TServidor.WHATSAPP then
  begin
    FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
      cbPageSize);
  end
  else
    TUtils.RemoverElementoPorId('btnPersonalizarTabela');

  TUtils.SetValorDicionarioClasses('logs_sistema', 'active');
  TUtils.SetPaginaSelecionada;

  FFiltroTodosServidores := EmptyStr;

  PreencherCombo;

  if DMConnection.FServidor = TServidor.WHATSAPP then
  begin
    asm
      $('li.nav-item.active').removeClass('active');
      $('#logs_sistema_li').addClass('active');
    end;
  end;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Logs_SistemaDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltroCombo;
  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewLogs_SistemaList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.logs_sistema.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.logs_sistema.list.table');
  cbPageSize := TComboBox.Create('view.logs_sistema.list.cbPageSize');
  edSearch := TEdit.Create('view.logs_sistema.list.search');
  lcPaginator := TListControl.Create('view.logs_sistema.list.pagination');
  edtLog := TEdit.Create('edtLog');
  cbbServidor := TComboBox.Create('cbbServidor');
  Logs_SistemaDataset := TXDataWebDataSet.Create(Self);
  Logs_SistemaDatasettabela := TStringField.Create(Self);
  Logs_SistemaDatasetservidor := TIntegerField.Create(Self);
  Logs_SistemaDatasetoperacao := TStringField.Create(Self);
  Logs_SistemaDatasetlog := TStringField.Create(Self);
  Logs_SistemaDatasetinclusao := TDateTimeField.Create(Self);
  Logs_SistemaDatasetusuarionome := TXDataWebDatasetField.Create(Self);
  Logs_SistemaDatasetaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  Logs_SistemaDatasetaliadocidadeNome := TXDataWebDatasetField.Create(Self);
  Logs_SistemaDatasetaliadocidadeufSigla := TXDataWebDatasetField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  edtLog.BeforeLoadDFMValues;
  cbbServidor.BeforeLoadDFMValues;
  Logs_SistemaDataset.BeforeLoadDFMValues;
  Logs_SistemaDatasettabela.BeforeLoadDFMValues;
  Logs_SistemaDatasetservidor.BeforeLoadDFMValues;
  Logs_SistemaDatasetoperacao.BeforeLoadDFMValues;
  Logs_SistemaDatasetlog.BeforeLoadDFMValues;
  Logs_SistemaDatasetinclusao.BeforeLoadDFMValues;
  Logs_SistemaDatasetusuarionome.BeforeLoadDFMValues;
  Logs_SistemaDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  Logs_SistemaDatasetaliadocidadeNome.BeforeLoadDFMValues;
  Logs_SistemaDatasetaliadocidadeufSigla.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewLogs_SistemaList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Log';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'usuario.nome';
      Title := 'Usu'#225'rio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.cidade.Nome';
      Title := 'Cidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tabela';
      Title := 'Tabela';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'servidor';
      Title := 'Servidor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'operacao';
      Title := 'Opera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    edtLog.SetParentComponent(Self);
    edtLog.Name := 'edtLog';
    edtLog.Left := 8;
    edtLog.Top := 422;
    edtLog.Width := 250;
    edtLog.Height := 22;
    edtLog.ChildOrder := 31;
    edtLog.Enabled := False;
    edtLog.HeightPercent := 100.000000000000000000;
    edtLog.Text := 'edtLog';
    edtLog.WidthPercent := 100.000000000000000000;
    cbbServidor.SetParentComponent(Self);
    cbbServidor.Name := 'cbbServidor';
    cbbServidor.Left := 424;
    cbbServidor.Top := 448;
    cbbServidor.Width := 145;
    cbbServidor.Height := 21;
    cbbServidor.HeightPercent := 100.000000000000000000;
    cbbServidor.TabStop := False;
    cbbServidor.WidthPercent := 100.000000000000000000;
    SetEvent(cbbServidor, Self, 'OnChange', 'cbbServidorChange');
    cbbServidor.ItemIndex := -1;
    Logs_SistemaDataset.SetParentComponent(Self);
    Logs_SistemaDataset.Name := 'Logs_SistemaDataset';
    Logs_SistemaDataset.EntitySetName := 'Logs_Sistema';
    Logs_SistemaDataset.Connection := DMConnection.ApiConnection;
    Logs_SistemaDataset.Left := 72;
    Logs_SistemaDataset.Top := 144;
    Logs_SistemaDatasettabela.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasettabela.Name := 'Logs_SistemaDatasettabela';
    Logs_SistemaDatasettabela.FieldName := 'tabela';
    Logs_SistemaDatasettabela.Required := True;
    Logs_SistemaDatasettabela.Size := 255;
    Logs_SistemaDatasetservidor.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetservidor.Name := 'Logs_SistemaDatasetservidor';
    Logs_SistemaDatasetservidor.FieldName := 'servidor';
    Logs_SistemaDatasetservidor.Required := True;
    Logs_SistemaDatasetoperacao.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetoperacao.Name := 'Logs_SistemaDatasetoperacao';
    Logs_SistemaDatasetoperacao.FieldName := 'operacao';
    Logs_SistemaDatasetoperacao.Required := True;
    Logs_SistemaDatasetoperacao.Size := 255;
    Logs_SistemaDatasetlog.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetlog.Name := 'Logs_SistemaDatasetlog';
    Logs_SistemaDatasetlog.FieldName := 'log';
    Logs_SistemaDatasetlog.Required := True;
    Logs_SistemaDatasetlog.Size := 255;
    Logs_SistemaDatasetinclusao.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetinclusao.Name := 'Logs_SistemaDatasetinclusao';
    Logs_SistemaDatasetinclusao.FieldName := 'inclusao';
    Logs_SistemaDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Logs_SistemaDatasetusuarionome.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetusuarionome.Name := 'Logs_SistemaDatasetusuarionome';
    Logs_SistemaDatasetusuarionome.FieldKind := fkCalculated;
    Logs_SistemaDatasetusuarionome.FieldName := 'usuario.nome';
    Logs_SistemaDatasetusuarionome.Calculated := True;
    Logs_SistemaDatasetaliadoNome_Fantasia.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetaliadoNome_Fantasia.Name := 'Logs_SistemaDatasetaliadoNome_Fantasia';
    Logs_SistemaDatasetaliadoNome_Fantasia.FieldKind := fkCalculated;
    Logs_SistemaDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    Logs_SistemaDatasetaliadoNome_Fantasia.Calculated := True;
    Logs_SistemaDatasetaliadocidadeNome.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetaliadocidadeNome.Name := 'Logs_SistemaDatasetaliadocidadeNome';
    Logs_SistemaDatasetaliadocidadeNome.FieldKind := fkCalculated;
    Logs_SistemaDatasetaliadocidadeNome.FieldName := 'aliado.cidade.Nome';
    Logs_SistemaDatasetaliadocidadeNome.Calculated := True;
    Logs_SistemaDatasetaliadocidadeufSigla.SetParentComponent(Logs_SistemaDataset);
    Logs_SistemaDatasetaliadocidadeufSigla.Name := 'Logs_SistemaDatasetaliadocidadeufSigla';
    Logs_SistemaDatasetaliadocidadeufSigla.FieldKind := fkCalculated;
    Logs_SistemaDatasetaliadocidadeufSigla.FieldName := 'aliado.cidade.uf.Sigla';
    Logs_SistemaDatasetaliadocidadeufSigla.Calculated := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Logs_SistemaDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    edtLog.AfterLoadDFMValues;
    cbbServidor.AfterLoadDFMValues;
    Logs_SistemaDataset.AfterLoadDFMValues;
    Logs_SistemaDatasettabela.AfterLoadDFMValues;
    Logs_SistemaDatasetservidor.AfterLoadDFMValues;
    Logs_SistemaDatasetoperacao.AfterLoadDFMValues;
    Logs_SistemaDatasetlog.AfterLoadDFMValues;
    Logs_SistemaDatasetinclusao.AfterLoadDFMValues;
    Logs_SistemaDatasetusuarionome.AfterLoadDFMValues;
    Logs_SistemaDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    Logs_SistemaDatasetaliadocidadeNome.AfterLoadDFMValues;
    Logs_SistemaDatasetaliadocidadeufSigla.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
